import { createStore, createEvent } from 'effector';

export const $userData = createStore({});
export const $userDataLoaded = createStore(false);

export const setUserData = createEvent();
export const setUserDataLoaded = createEvent();
export const setBlockChat = createEvent();

$userData
    .on(setUserData, (_, value) => value)
    .on(setBlockChat, (state, value) => ({...state, chatIsBlocked: value}));

$userDataLoaded
    .on(setUserDataLoaded, (_, value) => value);